import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import MaterialTable from '../components/MaterialTable';

const Material = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isMaterialModalOpen, setIsMaterialModalOpen] = useState(false);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.MATERIAL}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_MATERIAL,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsMaterialModalOpen(true);
            }}
          >
            Add New Material
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_MATERIAL,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsMaterialModalOpen(true);
            }}
          >
            Add New Material
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <MaterialTable
          isMaterialModalOpen={isMaterialModalOpen}
          setIsMaterialModalOpen={setIsMaterialModalOpen}
        />
      </Card>
    </>
  );
};

export default Material;
